import { useEffect, useState } from 'react';

export default function useBreakpoint(mediaQuery: string) {
    const [matches, setMatches] = useState<boolean>(() =>
        typeof window === 'undefined' ? false : window.matchMedia(mediaQuery).matches,
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mq = window.matchMedia(mediaQuery);

        const handler = (e: MediaQueryListEvent) => {
            setMatches(e.matches);
        };

        mq.addEventListener?.('change', handler);
        mq.addListener?.(handler);

        setMatches(mq.matches);

        return () => {
            mq.removeEventListener?.('change', handler);
            mq.removeListener?.(handler);
        };
    }, [mediaQuery]);

    return matches;
}
